import { render, staticRenderFns } from "./ChgPwd.vue?vue&type=template&id=1aa75c48&scoped=true"
import script from "./ChgPwd.vue?vue&type=script&lang=js"
export * from "./ChgPwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa75c48",
  null
  
)

export default component.exports